import { AuthCard } from '../features/auth/components';
import icon from '../assets/dd-icon.png';
import { Input } from '../components/Form/Input';
import { Button } from '../components/Form/Button';
import { useOrganizationStore } from '../shared/organization/organizationStore';
import { useEffect, useState } from 'react';
import { useAuthStore } from '../features/auth/authStore';
import {
  fetchOrganization,
  updateOrganizationAction,
} from '../shared/organization/organizationActions';
import { updateUserProfileAction } from '../features/auth/authActions';
import { useNavigate } from 'react-router-dom';

const CreateProfile = () => {
  const auth = useAuthStore((state) => state.auth);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    displayName: '',
    orgName: '',
    slug: '',
  });
  const org = useOrganizationStore((state) => state.organization);
  const disabled = auth?.memberships[0].role != 'owner';

  const initials = formData?.displayName
    ?.split(' ')
    .map((n) => n[0])
    .join('');

  useEffect(() => {
    if (!org && auth?.memberships[0].organizationId) {
      fetchOrganization(auth?.memberships[0].organizationId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [org]);

  useEffect(() => {
    if (auth) {
      setFormData({
        ...formData,
        firstName: auth?.firstName || auth?.displayName?.split(' ')[0] || '',
        lastName: auth?.lastName || auth?.displayName?.split(' ')[1] || '',
        displayName: auth?.displayName || '',
        orgName: org?.name || '',
        slug: org?.slug || '',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // Update organization if it exists and the name or slug has changed
    try {
      if (
        org &&
        org?.id &&
        org?.name !== formData.orgName &&
        org?.slug !== formData.slug
      ) {
        await updateOrganizationAction({
          id: org.id,
          name: formData.orgName,
          slug: formData.slug,
        });
      }
      // Update user profile if the display name has changed
      if (auth?.displayName !== formData?.displayName) {
        await updateUserProfileAction({
          firstName: formData.firstName,
          lastName: formData.lastName,
          displayName: `${formData.firstName} ${formData.lastName}`,
        });
      }
      return navigate(`/v1/dashboard`);
    } catch (error) {
      console.error('Error updating profile:', error);
    }
  };

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
      displayName: `${formData.firstName} ${formData.lastName}` || '',
    });
  };

  const handleOrgName = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      orgName: e.target.value,
      slug: e.target.value
        .toLowerCase()
        .replace(/[^\w\s-]/g, '') // remove punctuation
        .replace(/\s+/g, '-'), // replace spaces with hyphens
    });
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="sm:mx-auto sm:w-full sm:max-w-md mb-10">
        <img alt="DrillDown" src={icon} className="mx-auto h-16 w-auto" />
        <h2 className="mt-6 text-center text-2xl/9 font-bold tracking-tight text-gray-900">
          Create Profile
        </h2>
      </div>
      <AuthCard>
        <div className="flex items-center justify-center">
          {auth?.photoURL ? (
            <img
              alt="User"
              src={auth?.photoURL || 'https://randomuser.com/api/port'}
              className="size-12 rounded-full bg-gray-50"
            />
          ) : (
            <span className="flex size-12 shrink-0 items-center justify-center rounded-full border bg-gray-50 text-sm font-medium border-gray-200 text-gray-500 group-hover:border-indigo-600 group-hover:text-indigo-600">
              {initials}
            </span>
          )}
        </div>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="flex gap-2">
            <Input
              name="firstName"
              label="First Name"
              type="text"
              placeholder="Jane"
              value={formData.firstName}
              onChange={handleInput}
              className="w-full"
              required
            />
            <Input
              name="lastName"
              label="Last Name"
              type="text"
              placeholder="Doe"
              value={formData.lastName}
              onChange={handleInput}
              className="w-full"
              required
            />
          </div>
          <div className="relative my-4">
            <div
              aria-hidden="true"
              className="absolute inset-0 flex items-center"
            >
              <div className="w-full border-t border-gray-200" />
            </div>
            <div className="relative flex justify-center text-sm/6 font-medium">
              <span className="bg-white px-6 text-gray-900">
                Company Details
              </span>
            </div>
          </div>
          <Input
            name="orgName"
            label="Organization Name"
            type="text"
            placeholder="My Organization"
            value={formData.orgName}
            onChange={handleOrgName}
            className="w-full"
            disabled={disabled}
          />
          {/* <Input
            name='slug'
            label='URL Slug'
            type='text'
            placeholder='my-organization'
            value={formData.slug}
            onChange={handleInput}
            className='w-full'
            disabled={disabled}
          /> */}
          <Button type="submit" variant="primary" className="w-full py-2 text">
            Save Profile
          </Button>
        </form>
      </AuthCard>
    </div>
  );
};
export default CreateProfile;
